import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import { useGetPumpStatuses } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import type { SWRResponse } from "swr"
import useSWR from "swr"

import { usePumpStatusesSWRKey } from "./usePumpStatusesSWRKey"

export function usePumpStatuses(): SWRResponse<Array<PumpStatus>> {
  const pumpStatusesSWRKey = usePumpStatusesSWRKey()
  const getPumpStatuses = useGetPumpStatuses()

  const getPumpStatusesData = useMemo(
    () => !getPumpStatuses ? null : (async () => {
      const response = await getPumpStatuses({ params: {} })
      return response
    }),
    [getPumpStatuses],
  )

  return useSWR<Array<PumpStatus>>(
    pumpStatusesSWRKey,
    getPumpStatusesData,
  )
}
